import React from "react";

export const ExpandIcon = ({ width = 24, height = 24, color = "#ffffff" }) => (
    <svg width={`${width}px`} height={`${height}px`} strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
        <path d="M9 9L4 4M4 4V8M4 4H8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M15 9L20 4M20 4V8M20 4H16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M9 15L4 20M4 20V16M4 20H8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        <path d="M15 15L20 20M20 20V16M20 20H16" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
)